import { useMutation } from 'convex/react'; // CROSS_IMPORT_JUSTIFIED: convex/react is the official client-side React bindings package, not a server module
import { api } from '@convex/_generated/api';
import type { Id } from '@convex/_generated/dataModel';
import type { TRequestStatus } from '@/@types/leadInsuranceRequest';

export function useUpdateRequestStatus(): (
  requestId: Id<'leadInsuranceRequests'>,
  status: TRequestStatus
) => Promise<void> {
  const mutate = useMutation(api.leadInsuranceRequests.mutations.setStatus);
  return async (requestId, status) => {
    await mutate({ requestId, status });
  };
}
